import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import PrivateRoute from "./PrivateRoute";
import ProtectedRoute from "./ProtectedRoute";
import Login from "../Pages/Auth/Login";
import ForgetPassword from "../Pages/Auth/ForgotPassword";
import Verification from "../Pages/Auth/Verification";
import SetPassword from "../Pages/Auth/SetPassword";
import Profile from "../Pages/Profile";
import EditProfile from "../Pages/Profile/EditProfile";
import ChangePassword from "../Pages/Profile/ChangePassword";
import Notifications from "../Pages/Notifications";
import Dashboard from "../Pages/Dashboard";
import UserManagement from "../Pages/UserManagement";
import UserDetails from "../Pages/UserManagement/UserDetails";
import MoverManagement from "../Pages/MoverManagement";
import MoverDetails from "../Pages/MoverManagement/MoverDetails";
import SignupRequests from "../Pages/MoverManagement/SignupRequests";
import SignupRequestDetails from "../Pages/MoverManagement/SignupRequestDetails";
// import VehicleRequests from "../Pages/MoverManagement/VehicleRequests";
// import VehicleRequestDetails from "../Pages/MoverManagement/_VehicleRequestDetails";
import EditVehicleDetails from "../Pages/MoverManagement/_EditVehicleDetails";
import RidesManagement from "../Pages/RidesManagement";
import RideDetails from "../Pages/RidesManagement/RideDetails";
import Earnings from "../Pages/Earnings";
import EarningDetails from "../Pages/Earnings/EarningDetails";
import DriverPayouts from "../Pages/DriverPayouts";
import Feedbacks from "../Pages/Feedbacks";
import FeedbackDetails from "../Pages/Feedbacks/FeedbackDetails";
import RideReviews from "../Pages/RideReviews";

import VehicleManagement from "../Pages/VehicleManagement";
import VehicleDetails from "../Pages/VehicleManagement/VehicleDetails";

// Disabled: vehicle approve/reject — now handled via Driver Signup Requests
// import VehicleRequests from "../Pages/VehicleManagement/VehicleRequests";
// import VehicleRequestDetails from "../Pages/VehicleManagement/VehicleRequestDetails";

import VehicleTypeManagement from "../Pages/VehicleTypeManagement";
import AddVehicleType from "../Pages/VehicleTypeManagement/AddVehicleType";
import EditVehicleType from "../Pages/VehicleTypeManagement/EditVehicleType";
import CategoryManagement from "../Pages/CategoryManagement";
import AddCategory from "../Pages/CategoryManagement/AddCategory";
import EditCategory from "../Pages/CategoryManagement/EditCategory";
import PaymentLogs from "../Pages/PaymentLogs";
import Settings from "../Pages/Settings";
import EditSetting from "../Pages/Settings/EditSetting";
import Chat from "../Pages/Chat";
import PageNotFound from "../Pages/PageNotFound";
import Reports from "../Pages/Reports";
import ReportDetails from "../Pages/Reports/ReportDetails";
import Aboutus from "../Pages/Content/Aboutus";
import PrivacyPolicy from "../Pages/Content/PrivacyPolicy";
import Terms from "../Pages/Content/Terms";
import ViewVehicleType from "../Pages/VehicleTypeManagement/ViewVehicleType";
import PromoCodes from "../Pages/PromoCodes";
import AddPromoCode from "../Pages/PromoCodes/AddPromoCode";
import EditPromoCode from "../Pages/PromoCodes/EditPromoCode";
import NotificationManagement from "../Pages/NotificationManagement";
import NotificationTemplates from "../Pages/NotificationManagement/NotificationTemplates";
import AddNotification from "../Pages/NotificationManagement/AddNotification";
import CMSManagement from "../Pages/CMSManagement";
import FAQManagement from "../Pages/FAQManagement";
import CancellationManagement from "../Pages/CancellationManagement";
import AddCancellationReason from "../Pages/CancellationManagement/AddCancellationReason";
import EditCancellationReason from "../Pages/CancellationManagement/EditCancellationReason";
import Onboarding from "../Pages/Onboarding";
import LandingPageCMS from "../Pages/LandingPageCMS";
import ContactInquiries from "../Pages/ContactInquiries";

import { useLocation } from "react-router-dom";
import { useEffect } from "react";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

export default function Router() {
  return (
    <>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Onboarding />} />
        <Route path="/superadmin" element={<ProtectedRoute><Login /></ProtectedRoute>} />
        <Route path="/admin" element={<Navigate to="/superadmin" replace />} />
        <Route path="/login" element={<Navigate to="/superadmin" replace />} />
        <Route path="/forgot-password" element={<ProtectedRoute><ForgetPassword /></ProtectedRoute>} />
        <Route path="/verification" element={<ProtectedRoute><Verification /></ProtectedRoute>} />
        <Route path="/set-password" element={<ProtectedRoute><SetPassword /></ProtectedRoute>} />

        <Route path="/profile" element={<PrivateRoute><Profile /></PrivateRoute>} />
        <Route path="/profile/edit" element={<PrivateRoute><EditProfile /></PrivateRoute>} />
        <Route path="/profile/change-password" element={<PrivateRoute><ChangePassword /></PrivateRoute>} />
        <Route path="/notifications" element={<PrivateRoute><Notifications /></PrivateRoute>} />
        <Route path="/chat" element={<PrivateRoute><Chat /></PrivateRoute>} />

        <Route path="/vehicle-type-management" element={<PrivateRoute><VehicleTypeManagement /></PrivateRoute>} />
        <Route path="/vehicle-type-management/view/:id" element={<PrivateRoute><ViewVehicleType /></PrivateRoute>} />
        <Route path="/vehicle-type-management/add" element={<PrivateRoute><AddVehicleType /></PrivateRoute>} />
        <Route path="/vehicle-type-management/edit/:id" element={<PrivateRoute><EditVehicleType /></PrivateRoute>} />
        <Route path="/payment-logs" element={<PrivateRoute><PaymentLogs /></PrivateRoute>} />
        <Route path="/settings" element={<PrivateRoute><Settings /></PrivateRoute>} />
        <Route path="/settings/edit" element={<PrivateRoute><EditSetting /></PrivateRoute>} />

        <Route path="/dashboard" element={<PrivateRoute><Dashboard /></PrivateRoute>} />
        <Route path="/user-management" element={<PrivateRoute><UserManagement /></PrivateRoute>} />
        <Route path="/user-management/user-details/:id" element={<PrivateRoute><UserDetails /></PrivateRoute>} />
        <Route path="/mover-management" element={<PrivateRoute><MoverManagement /></PrivateRoute>} />
        <Route path="/mover-management/mover-details/:id" element={<PrivateRoute><MoverDetails /></PrivateRoute>} />
        <Route path="/mover-management/signup-requests" element={<PrivateRoute><SignupRequests /></PrivateRoute>} />
        <Route path="/mover-management/signup-requests/:id" element={<PrivateRoute><SignupRequestDetails /></PrivateRoute>} />
        {/* <Route path="/mover-management/vehicle-requests" element={<PrivateRoute><VehicleRequests /></PrivateRoute>} />
      <Route path="/mover-management/vehicle-requests/:id" element={<PrivateRoute><VehicleRequestDetails /></PrivateRoute>} /> */}
        <Route path="/mover-management/mover-details/:id/vehicle-details/:vehicleId" element={<PrivateRoute><EditVehicleDetails /></PrivateRoute>} />
        <Route path="/ride-management" element={<PrivateRoute><RidesManagement /></PrivateRoute>} />
        <Route path="/ride-management/ride-details/:id" element={<PrivateRoute><RideDetails /></PrivateRoute>} />
        <Route path="/earnings" element={<PrivateRoute><Earnings /></PrivateRoute>} />
        <Route path="/earnings/earning-details/:id" element={<PrivateRoute><EarningDetails /></PrivateRoute>} />
        <Route path="/driver-payouts" element={<PrivateRoute><DriverPayouts /></PrivateRoute>} />
        <Route path="/feedbacks" element={<PrivateRoute><Feedbacks /></PrivateRoute>} />
        <Route path="/feedbacks/feedback-details/:id" element={<PrivateRoute><FeedbackDetails /></PrivateRoute>} />
        <Route path="/ride-reviews" element={<PrivateRoute><RideReviews /></PrivateRoute>} />
        <Route path="/business-management/*" element={<Navigate to="/dashboard" replace />} />

        <Route path="/vehicle-management" element={<PrivateRoute><VehicleManagement /></PrivateRoute>} />
        <Route path="/vehicle-management/vehicle-details/:id" element={<PrivateRoute><VehicleDetails /></PrivateRoute>} />

        {/* Disabled: vehicle approve/reject — now handled via Driver Signup Requests
      <Route path="/vehicle-management/vehicle-requests" element={<PrivateRoute><VehicleRequests /></PrivateRoute>} />
      <Route path="/vehicle-management/vehicle-requests-details/:id" element={<PrivateRoute><VehicleRequestDetails /></PrivateRoute>} />
      */}


        <Route path="/category-management" element={<PrivateRoute><CategoryManagement /></PrivateRoute>} />
        <Route path="/category-management/add" element={<PrivateRoute><AddCategory /></PrivateRoute>} />
        <Route path="/category-management/edit/:id" element={<PrivateRoute><EditCategory /></PrivateRoute>} />
        <Route path="/reports" element={<PrivateRoute><Reports /></PrivateRoute>} />
        <Route path="/reports/reports-details/:id" element={<PrivateRoute><ReportDetails /></PrivateRoute>} />

        <Route path="/promo-codes" element={<PrivateRoute><PromoCodes /></PrivateRoute>} />
        <Route path="/promo-codes/add" element={<PrivateRoute><AddPromoCode /></PrivateRoute>} />
        <Route path="/promo-codes/edit/:id" element={<PrivateRoute><EditPromoCode /></PrivateRoute>} />

        <Route path="/notification-management" element={<PrivateRoute><NotificationManagement /></PrivateRoute>} />
        <Route path="/notification-templates" element={<PrivateRoute><NotificationTemplates /></PrivateRoute>} />
        <Route path="/notification-management/add" element={<PrivateRoute><AddNotification /></PrivateRoute>} />

        <Route path="/cms-management" element={<PrivateRoute><CMSManagement /></PrivateRoute>} />
        <Route path="/faq-management" element={<PrivateRoute><FAQManagement /></PrivateRoute>} />
        <Route path="/cancellation-management" element={<PrivateRoute><CancellationManagement /></PrivateRoute>} />
        <Route path="/cancellation-management/add" element={<PrivateRoute><AddCancellationReason /></PrivateRoute>} />
        <Route path="/cancellation-management/edit/:id" element={<PrivateRoute><EditCancellationReason /></PrivateRoute>} />
        <Route path="/landing-cms" element={<PrivateRoute><LandingPageCMS /></PrivateRoute>} />
        <Route path="/contact-inquiries" element={<PrivateRoute><ContactInquiries /></PrivateRoute>} />

        <Route path="/about-us" element={<Aboutus />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms-and-condition" element={<Terms />} />
        <Route path="/onboarding" element={<Navigate to="/" replace />} />
        <Route path="/onboarding-app" element={<Navigate to="/" replace />} />
        <Route path="/landing" element={<Navigate to="/" replace />} />
        <Route path="*" element={<PageNotFound />} />
      </Routes>
    </>
  );
}
